import { Map } from 'immutable'
import { categoryToCategoryItem } from './categoryTransformers'
import { getItemsByIds } from '../../selectors/itemsSelector'
import { selectCategoryById } from '../../selectors/categoriesSelector'
import { selectTagItemsBySlugs } from '../../selectors/tagsSelector'
import { selectUserBlacklistedSourceIds, selectUserCategories } from '../../selectors/userSelector'

export function itemIdsToItems(state, itemIds) {
  const items = getItemsByIds(state, itemIds)
  return items.map(item => itemToNewsListItem(item, state))
}

/**
 * @param {ItemRecord} item
 * @param {object} state
 * @returns {Immutable.Map<string,unknown>}
 */
function itemToNewsListItem(item, state) {
  const {
    id,
    title,
    link,
    source,
    sourceId,
    tags,
    categoryId,
    timestamp,
    clicks,
    plus_votes,
    minus_votes,
    currentVote,
    currentReport,
    batchId,
    batchSize,
    custom,
    paywalled,
  } = item

  const itemCategory = selectCategoryById(state, categoryId)
  const blacklistedSource = selectUserBlacklistedSourceIds(state).includes(sourceId)

  return Map({
    id,
    title,
    link,
    source,
    sourceId,
    blacklistedSource,
    category: categoryToCategoryItem(itemCategory, selectUserCategories(state)),
    tags: selectTagItemsBySlugs(state, tags),
    timestamp,
    clicks,
    plus_votes,
    minus_votes,
    currentVote,
    currentReport,
    batchId,
    batchSize,
    custom,
    paywalled,
  })
}
